export const getNonNullString = (
  inputString: string | null | undefined,
  replacement = ''
) => {
  if (!inputString) {
    return replacement
  }
  return inputString
}
